import { useEffect, useRef, useState } from 'react';
import './App.css';
import './devlink/global.css';
import Millis from '@millisai/web-sdk';
import { Button, Grid, Stack, TextField, ThemeProvider, Typography, createTheme, styled } from '@mui/material';

enum State {
  IDLE,
  CONNECTING,
  READY,
}

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
  },
});

function Test() {
  const urlParams = new URLSearchParams(window.location.search);
  const [host, setHost] = useState("ws://localhost:8080/millis");
  const N = parseInt(urlParams.get('n') || '10', 10);
  const clientsRef = useRef([...Array(N)].map(() => Millis.createClient({publicKey: "millis_ai_demo_key", endPoint: "ws://localhost:8080/millis", debug: true, isBenchmark: true})));
  const [callStates, setCallStates] = useState([...Array(N)].map(() => State.IDLE));
  const [transcripts, setTranscripts] = useState([...Array(N)].map(() => ""));
  const [userTranscripts, setUserTranscripts] = useState([...Array(N)].map(() => ""));

  const updateState = (i: number, state: State) => {
    setCallStates((callStates) => [...callStates.slice(0, i), state, ...callStates.slice(i + 1)]);
  };

  const updateTranscript = (i: number, transcript: string) => {
    setTranscripts((transcripts) => [...transcripts.slice(0, i), transcript, ...transcripts.slice(i + 1)]);
  };

  const updateUserTranscript = (i: number, transcript: string) => {
    setUserTranscripts((userTranscripts) => [...userTranscripts.slice(0, i), transcript, ...userTranscripts.slice(i + 1)]);
  };

  const startAll = async () => {
    clientsRef.current.forEach((client) => client.start({
      prompt: "You're a helpful assistant named Ben",
      voice: {provider: "elevenlabs", voice_id: "Rachel"},
    }));
  };

  const stopAll = async () => {
    clientsRef.current.forEach((client) => client.stop());
  };
  const handleHostChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setHost(event.target.value);
  };

  useEffect(() => {
    clientsRef.current = [...Array(N)].map(() => Millis.createClient({publicKey: "millis_ai_demo_key", endPoint: host, debug: true, isBenchmark: true}));
    clientsRef.current.forEach((client, i) => {
      client.on("onready", () => {
        updateState(i, State.READY);
      });
      client.on("onclose", ({ code, reason }) => {
        updateState(i, State.IDLE); // Update button to "Start" when conversation ends
        updateTranscript(i, "");
        updateUserTranscript(i, "");
        console.log(">>>>>>>>>>>>>>> close", code, reason);
      });
      client.on("onresponsetext", (text: string) => {
        updateTranscript(i, text);
      });
      client.on("ontranscript", (data) => {
        updateUserTranscript(i, data);
      });
    });
  }, [host, N]);

  return (
    <ThemeProvider theme={darkTheme}>
    <div>
      <Stack direction="row" spacing={2}>
        <TextField label="Host" value={host} onChange={handleHostChange} />
      <Button onClick={startAll}>Start ALL</Button>
      <Button onClick={stopAll}>Stop ALL</Button>
      </Stack>
      <Grid container spacing={2}>
      {[...Array(N)].map((_, i) => (
        <Grid item xs={6} key={i}>
          <h3>Client {i} - {State[callStates[i]]}</h3>
          <p>Transcript: {transcripts[i]}</p><p>User transcript: {userTranscripts[i]}</p>
        </Grid>
      ))}
      </Grid>
    </div>
    </ThemeProvider>
  );
}

const Container = styled('div')({
  width: '100%',
  height: '4.8em', // Adjust this value based on your font size and line height to fit exactly two lines
  overflowY: 'hidden',
  position: 'relative',
});

const ScrollableText = styled(Typography)({
  width: '100%',
  whiteSpace: 'pre-wrap',
  wordWrap: 'break-word',
  overflow: 'hidden',
});


const TextContainer = ({ text }: {text: string}) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }
  }, [text]);

  return (
    <Container ref={containerRef}>
      <ScrollableText>
        {text}
      </ScrollableText>
    </Container>
  );
};

export default Test;
